import { LegalPageFooter } from 'components/LegalPageFooter';
import { Layout } from 'components/Layout';
import { Seo } from 'components/Seo';

import { Container, HeroContainer, Section } from 'components/Container';
import { NumberedListNested, NumberedListGroup, List } from 'components/List';
import { termsOfUseClauses as clauses, termsOfUseHeaders } from 'page-data/termsOfUse';

import type { FC } from 'react';
import type { LocalizedPageProps } from '@sharesight/gatsby-plugin-sharesight-localization';

const lastUpdatedDate: Date = new Date('2023-02-20');

const SharesightTermsOfUse: FC<LocalizedPageProps> = () => (
  <Layout>
    <Seo />
    <HeroContainer background="cream" id="header">
      <Section>
        <h1>Terms of Use – Sharesight</h1>
        <List isNumbered noIndent bulletPadding={1} itemGap={0} items={termsOfUseHeaders} />
      </Section>
    </HeroContainer>

    <NumberedListGroup>
      {clauses.map(c => (
        <Container key={c.header}>
          <Section>
            <NumberedListNested header={c.header} clauses={c.clauses} />
          </Section>
        </Container>
      ))}
    </NumberedListGroup>

    {/* Floating to the top button */}
    <LegalPageFooter elementId="header" date={lastUpdatedDate} />
  </Layout>
);

export default SharesightTermsOfUse;
